import { AdendoPecas } from './../../model/adendo/adendoPecas';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { GenericService } from '../generics/generic.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdendoPecasService extends GenericService<AdendoPecas> {
  constructor(http: HttpClient) {
    super(http);
    super.initResource("adendopecas")
  }


  updateConstituicao(idCompany: number, id: number, idConstituicao: number, idRegra: number): Observable<AdendoPecas> {
    const urlLocal = `${this.url}/constituicao/${idCompany}/${id}/${idConstituicao}/${idRegra}`;
    return this.http.patch<AdendoPecas>(urlLocal, this.httpOptions);
  }

  updateAplicacao(idCompany: number, id: number, idAplicacao: number, idRegra: number): Observable<AdendoPecas> {
    const urlLocal = `${this.url}/aplicacao/${idCompany}/${id}/${idAplicacao}/${idRegra}`;
    return this.http.patch<AdendoPecas>(urlLocal, this.httpOptions);
  }


  getPorPN(idCompany: number, pn: string): Observable<AdendoPecas[]> {
    const url = `${this.url}/pn/${idCompany}/${pn}`;
    return this.http.get<AdendoPecas[]>(url);
  }

  getAdendoPorFabricante(idCompany: number, fabricanteId: number): Observable<AdendoPecas[]> {
    const url = `${this.url}/fabricante/${idCompany}/${fabricanteId}/itens`;
    return this.http.get<AdendoPecas[]>(url);
  }

  // Método para buscar estoque disponível
  getEstoqueDisponivel(pn: string): Observable<any[]> {
    const url = `${this.url}/estoque/${pn}`;
    return this.http.get<any[]>(url);
  }

  // Método para buscar estatísticas por empresa
  buscarEstatisticas(idEmpresa: number): Observable<any> {
    const url = `${this.url}/estatisticas/${idEmpresa}`;
    return this.http.get<any>(url);
  }

  // Método para buscar todos os locais por empresa
  buscarLocais(idEmpresa: number): Observable<string[]> {
    const url = `${this.url}/locais/${idEmpresa}`;
    return this.http.get<string[]>(url);
  }

  // Método para buscar peças por local e empresa
  buscarPecasPorLocal(idEmpresa: number, local: string): Observable<any[]> {
    // ✅ Encode o local e passa como query parameter (?local=...)
    const localEncoded = encodeURIComponent(local);
    const url = `${this.url}/local/${idEmpresa}/pecas?local=${localEncoded}`;
    return this.http.get<any[]>(url);
  }

  // Método para buscar locais com estatísticas
  buscarLocaisComEstatisticas(idEmpresa: number): Observable<any[]> {
    const url = `${this.url}/locais-estatisticas/${idEmpresa}`;
    return this.http.get<any[]>(url);
  }

  buscarPnsSemLocal(idEmpresa: number): Observable<any> {
    return this.http.get(`${this.url}/pns-sem-local/${idEmpresa}`);
  }

  buscarPecasSemLocal(idEmpresa: number): Observable<any[]> {
    const url = `${this.url}/sem-local/${idEmpresa}/pecas`;
    return this.http.get<any[]>(url);
  }

  // No adendo-pecas.service.ts
  buscarLocalPorPN(idEmpresa: number, pn: string): Observable<any> {
    const url = `${this.url}/local/${idEmpresa}/buscarPorPN/${pn}`;
    return this.http.get<any>(url);
  }

  compararNcmXml(formData: FormData): Observable<any> {
    return this.http.post(`${this.url}/comparar-ncm-xml`, formData);
  }

  atualizarNcm(apeId: number, ncmId: string): Observable<any> {
    return this.http.patch(`${this.url}/${apeId}/ncm/${ncmId}`, {});
  }

  atualizarNcmsEmLote(atualizacoes: any[]): Observable<any> {
    return this.http.patch(`${this.url}/ncm/lote`, atualizacoes);
  }

  // ==========================================================
  // Alíquota de IPI (FISCAL_NCM) - fluxo independente do NCM
  // ==========================================================

  compararAliquotaIpi(itens: any[]): Observable<any> {
    return this.http.post(`${this.url}/comparar-ipi-itens`, itens);
  }

  atualizarAliquotaIpi(ncmId: number | string, aliquotaIpi: number, pns?: string[]): Observable<any> {
    return this.http.patch(`${this.url}/ipi/${ncmId}`, { aliquotaIpi, pns });
  }

  atualizarAliquotaIpiEmLote(atualizacoes: any[]): Observable<any> {
    return this.http.patch(`${this.url}/ipi/lote`, atualizacoes);
  }

  // Método para autocomplete otimizado de P/N
  autocompletePn(idEmpresa: number, termo: string): Observable<any[]> {
    const url = `${this.url}/autocomplete/${idEmpresa}?termo=${encodeURIComponent(termo)}`;
    return this.http.get<any[]>(url, this.httpOptions);
  }

  corrigirEstoqueLote(idEmpresa: number, idUsuario: number): Observable<any> {
    const url = `${this.url}/corrigir-estoque-lote/${idEmpresa}/${idUsuario}`;
    return this.http.post<any>(url, {});
  }

  // Novo método para buscar código ou PN ignorando as permissões do sistema
  buscaLivre(idEmpresa: number, campo: string, valor: string): Observable<AdendoPecas[]> {
    const url = `${this.url}/busca-livre/${idEmpresa}?campo=${campo}&valor=${encodeURIComponent(valor)}`;
    return this.http.get<AdendoPecas[]>(url);
  }
}
